import * as React from 'react';
import { Button } from 'primereact/button';
import { IntlShape, useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { OrcidAuthorizeDTO, OrcidScopeDTO } from '../../../api/admin';
import { Mandant } from '../../../util/types';

interface Props {
  orcidAuthorize: OrcidAuthorizeDTO;
  revoke: () => void;
  mandant: Mandant;
}

export const OrcidRevokeRightsForm = ({orcidAuthorize, revoke, mandant}: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex flex-column gap-1'}>
      <div>
        <h4>{intl.formatMessage({ id: `settings.orcid.followingRightsGranted` })}</h4>
      </div>
      {(orcidAuthorize.orcidScopes || []).length > 0
        ? <ul>
          {orcidAuthorize.orcidScopes.map((orcidScope: OrcidScopeDTO, idx: number): ReactNode =>{
            switch(orcidScope.scope) {
              case '/read-limited':
                return (
                  <li key={idx}>
                    <h5>{intl.formatMessage({ id: `settings.orcid.scopes.readLimited` })}</h5>
                    <p>{intl.formatMessage({ id: `settings.orcid.scopes.readLimited.desc(mandant)`}, {mandant: intl.formatMessage({ id: `core.mandant.${mandant}`}) })}</p>
                  </li>
                );
              case '/activities/update':
                return (
                  <li key={idx}>
                    <h5>{intl.formatMessage({ id: `settings.orcid.scopes.activitiesUpdate` })}</h5>
                    <p>{intl.formatMessage({ id: 'settings.orcid.scopes.activitiesUpdate.desc(mandant)'}, {mandant: intl.formatMessage({ id: `core.mandant.${mandant}`}) })}</p>
                  </li>
                );
              case '/person/update':
                return (
                  <li key={idx}>
                    <h5>{intl.formatMessage({ id: `settings.orcid.scopes.personUpdate` })}</h5>
                    <p>{intl.formatMessage({ id: `settings.orcid.scopes.personUpdate.desc` })}</p>
                  </li>
                );
              default:
                return (
                  <li key={idx}>
                    <p>{orcidScope.scope}</p>
                  </li>
                );
            }
          })}
          {orcidAuthorize.publicUsageOfLimitedOrcidData &&
            <li key={'publicUsageOfLimitedOrcidData'}>
              <h5>{intl.formatMessage({ id: `settings.orcid.notLinked.publicUsageOfLimitedOrcidData` })}</h5>
            </li>
          }
        </ul>
        : <p>{intl.formatMessage({ id: `settings.orcid.no_rights_granted` })}</p>
      }
      <Button
        label={intl.formatMessage({ id: `settings.orcid.revoke_rights` })}
        onClick={revoke}
      />
    </div>
  );
};
